import React from "react";
import { Link } from "gatsby";
import unslugify from "../utils/unslugify";

const HeaderDesktopAd = ({ pathname, width }) => {
  const splittedPathname = pathname.split("/").filter((item) => item !== "");
  const lastPathname = splittedPathname[splittedPathname.length - 1];

  return (
    <header className="flex px-4 py-3 justify-between font-bold text-lg bg-[#ffff]">
      <nav className="flex flex-row justify-between w-full">
        <div className="flex flex-row gap-x-2">
          <Link
            to="/"
            className="uppercase hover:opacity-20 transition-all duration-300 "
          >
            {width > 768 ? "claudio majorana," : unslugify(lastPathname, true)}
          </Link>
          <span className="hidden md:block uppercase hover:cursor-default">
            {unslugify(lastPathname, false)}
          </span>
        </div>
        <Link
          to="/contacts/"
          className="uppercase hover:opacity-20 transition-all duration-300 "
        >
          {" "}
          Contacts
        </Link>
      </nav>
    </header>
  );
};

export default HeaderDesktopAd;
